/* eslint-disable no-useless-catch */
/* eslint-disable no-undef */
import { ENV } from "../utils";

export class ClassSchedule {
  baseApi = ENV.BASE_API;

  async getClassSchedules(accessToken, gradeId, academicCycleId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.CLASS_SCHEDULE}/grade/${gradeId}?academicCycleId=${academicCycleId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result.data || result; // Return the data array from the API response
    } catch (error) {
      throw error;
    }
  }

  async createClassSchedule(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.CLASS_SCHEDULE}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateClassSchedule(accessToken, classScheduleId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.CLASS_SCHEDULE}/${classScheduleId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteClassSchedule(accessToken, classScheduleId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.CLASS_SCHEDULE}/${classScheduleId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}